import { HIDDEN } from 'customer-data-objects/property/AccessLevel';
import { isLogicGroup } from '../filterQueryFormat/logic/LogicGroup';
import { isOperator } from '../filterQueryFormat/operator/Operator';
export const RESTRICTED_FILTER_VALUE = 'RESTRICTED';
export const isFilterValueHasRestrictedPropertiesUsingRestrictedValueCheck = filterValue => {
  const filterValueObject = filterValue || {};
  return filterValueObject.filterBranchOperator === RESTRICTED_FILTER_VALUE;
};
export const isFieldRestricted = accessLevel => {
  return accessLevel === HIDDEN;
};
const getPropertiesFromFilterValue = filterValue => {
  return filterValue.conditions.reduce((acc, condition) => {
    if (isLogicGroup(condition)) {
      return [...acc, ...getPropertiesFromFilterValue(condition)];
    }
    if (isOperator(condition) && condition.field) {
      return [...acc, condition.field];
    }
    return acc;
  }, []);
};
export const isFilterValueHasRestrictedPropertiesUsingManualCheck = filterValue => {
  if (!filterValue) {
    return false;
  }
  const properties = getPropertiesFromFilterValue(filterValue);
  return properties.some(property => isFieldRestricted(property.accessLevel));
};
export const RESTRICTED_OPTION_PROPS = {
  disabled: true,
  icon: 'hide'
};
export const RESTRICTED_OPTION_TOOLTIP = 'customerDataFiltersUI.customerDataFilters.FilterEditor.restrictedPropertyTooltip';